import { render, staticRenderFns } from "./printerForm.vue?vue&type=template&id=f504b84a"
import script from "./printerForm.vue?vue&type=script&lang=js"
export * from "./printerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports